<template>
  <div class="not-found" :style="notFoundStyle">
    <h1>Not Found</h1>
    <p>
      Missing art leaves a gap in the fabric of history, a blank space where a masterpiece once hung.
      <router-link to="/">Home</router-link>
    </p>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';
const bgImage = require('@/assets/img/404.jpg')

export default {
  computed: {
    notFoundStyle() {
      return { backgroundImage: `url(${bgImage})` }
    }
  },
}
</script>

<style scoped lang="scss">
.not-found {
  background-size: cover;
  height: calc(100vh - 230px);
  min-height: 380px;
  display:flex; 
  flex-direction: column;
  align-content: center;
  justify-content: center;
  text-align: center;
}
h1 {
  margin: .5em
}
p {
  max-width: 100%;
  margin: 0 .5em
}
a {
  color: $primary-accent-color
}
</style>